import { useTranslation } from "react-i18next";
import animationGif from "../../assets/images/Animation/global-education.gif";

const Layout = () => {
  const { t } = useTranslation();
  let baseUrl: string = `${window.location.origin}/${process.env.REACT_APP_CONTEXT_PATH}/`;

  return (
    <>
      <img src={`${baseUrl}${animationGif.replace('./', "")}`} width="500px" alt="global-education" />
      <div
        className="center white-font font-18"
        style={{ marginBottom: "14vh" }}
      >
        {t("login.trainedChildren")}
      </div>
    </>
  );
};
export default Layout;
